
const state = () => ({
	current_scopeflow: null,
	scopeflows: [],
	clientId: null,
	dimensions: null,
	results: null,
	nonClientScopeflows: null,
	selectedRow: {},
	isOsol: false
});

const getters = {
	getCurrentScopeflow: state => {
		return state.current_scopeflow;
	},
	getScopeflows: state => {
		return state.scopeflows;
	},
	getClientId: state => {
		return state.clientId;
	},
	getDimensions: state => {
		return state.dimensions !== null
			? state.dimensions.map((dimension) => dimension.value)
			: [];
	},
	getDimensionWSName: (state) => (dimensionValue) => {
		if (state.dimensions === null) return '';
		return state.dimensions.find((dimension) => dimension.value === dimensionValue)?.ws_name || '';
	},
	getScopeflowIfClient: (state) => (scopeflow_name) => {
		if (state.nonClientScopeflows === null) return true;
		let isClient = true;
		state.nonClientScopeflows.forEach((name) => {
			if (name === scopeflow_name) {
				isClient = false;
			}
		});
		return isClient;
	}
};

const mutations = {
	setScopeflows (state, scopeflows) {
		state.nonClientScopeflows = [];
		state.scopeflows = [];
		if (scopeflows != null) {
			scopeflows.forEach((scopeflow) => {
				state.scopeflows.push(scopeflow.name);
				if (scopeflow.isClient === false) {
					state.nonClientScopeflows.push(scopeflow.name);
				}
			});
		}
	},
	setDimensions (state, scopeflows) {
		if (scopeflows != null && scopeflows.length > 0) {
			const scopeflow = scopeflows[0];
			state.dimensions = scopeflow.dimensions;
		}
	},
	setClientId (state, scopeflows) {
		if (scopeflows != null && scopeflows.length > 0) {
			const scopeflow = scopeflows[0];
			state.clientId = scopeflow.client_id;
		}
	},
	setCurrentScopeflow (state, scopeflow) {
		state.current_scopeflow = scopeflow;
	},
	storeScopeflowsResult (state, results) {
		state.results = results;
	},
	setSelectedRow (state, row) {
		state.selectedRow = row;
	},
	resetResults (state) {
		state.results = null;
	},
	setIsOsol (state, isOsol) {
		state.isOsol = isOsol;
	}
};

const actions = {
};

export default {
	state,
	getters,
	actions,
	mutations
};
